// extracted by mini-css-extract-plugin
module.exports =  {"nav-tab-button-container":"nav-tab-button-container-dYhs0","icon":"icon-TzPrK","label":"label-BCz2f","logo":"logo-xJBE9"};